export const USER_ROLES = {
  companyAdmin: 'Company Admin',
  superAdmin: 'Super Admin',
  accountAdmin: 'Account Admin',
}
